import React from 'react'
import { defaultProps } from './index'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const IconCardSettings = (settingsProps) => {
  return <>{!settingsProps.floating && <ImageToolbarSection defaultProps={defaultProps} />}</>
}

export const IconCardFloatingSettings = () =>
  React.createElement(IconCardSettings, { floating: true })
